module.exports = __webpack_public_path__ + "static/media/exampleLegend4.f9068c05.png";